import Api from "./Api";

export const EventsService = {

    getAllEvents: async () => {

        const res = await Api.get("/events/allEvents");

        return res.data;

    }

};